export const SplashScreenViewGrid = {
	size: 100,
	gap: 0,
	padding: {
		top: 1,
		bottom: 1,
		left: 3,
		right: 6,
		landscape: {
			top: 3,
			bottom: 1,
			left: 3,
			right: 0
		},
		portrate: {
			top: 5,
			bottom: 5,
			left: 8,
			right: 8
		}
	},

	main: [
		{
			name: 'leftgrid-splash',
			size: 60,
			type: 'PortrateGridController',
			config: {
				size: 100,
				gap: 1,
				padding: {
					top: 10,
					bottom: 2,
					left: 12
				},
				main: [
					{
						name: 'logo',
						size: 12,
						align: 'center',
						bounds: {
							width: 90,
							height: 120
						}
					},
					{
						name: 'empty',
						size: 6
					},
					{
						name: 'slider_bg',
						size: 66,
						align: 'top_center',
						bounds: {
							width: 977,
							height: 669
						}
					}
				]
			}
		},
		{
			name: 'rightgrid',
			type: 'PortrateGridController',
			size: 30,
			config: {
				gap: 1,
				size: 100,
				align: 'left',
				padding: {
					top: 0,
					bottom: 5,
					right: 10
				},
				main: [
					{
						name: 'empty',
						size: 16
					},
					{
						name: 'fg',
						size: 35,
						align: 'bottom_center',
						bounds: {
							width: 293 / 2,
							height: 293 / 2
						}
					},
					{
						name: 'empty',
						size: 4
					},
					{
						name: 'texts',
						size: 10,
						align: 'top_center'
					},

					{
						name: 'ui_splash_screen_btn',
						size: 22,
						align: 'bottom_right',
						bounds: {
							width: 310,
							height: 224
						}
					},
					{
						name: 'empty',
						size: 4
					},
					{
						name: 'ui_splash_screen_checkbox',
						size: 6,
						align: 'center',
						bounds: {
							width: 240,
							height: 50
						}
					}
				]
			}
		}
	],

	portrate: [
		{
			name: 'logo',
			size: 8,
			align: 'center',
			bounds: {
				width: 216,
				height: 112
			}
		},
		{
			name: 'empty',
			size: 6
		},
		{
			name: 'fg',
			visible: false
		},
		{
			name: 'slider_bg',
			align: 'top_center',
			size: 40,
			bounds: {
				width: 982,
				height: 672
			}
			//  width: 90,
			//  height: 90,
		},
		{
			name: 'empty',
			size: 6
		},
		{
			name: 'texts',
			size: 10,
			// align: 'bottom_center',
			bounds: {
				width: 346,
				height: 111
			}
		},
		{
			name: 'empty',
			size: 3
		},
		{
			name: 'ui_splash_screen_btn',
			size: 17,
			align: 'top',
			bounds: {
				width: 284,
				height: 140
			}
		},
		{
			name: 'empty',
			size: 11
		},
		{
			name: 'ui_splash_screen_checkbox',
			size: 7
		}
	],

	landscape: [
		{
			name: 'leftgrid-land',
			size: 65,
			type: 'PortrateGridController',
			config: {
				size: 100,
				gap: 1,
				padding: {
					top: 5,
					bottom: 0,
					left: 5
				},
				main: [
					{
						name: 'empty',
						size: 5
					},
					{
						name: 'logo',
						size: 16,
						align: 'bottom_center',
						bounds: {
							width: 170,
							height: 146
						}
					},
					{
						name: 'empty',
						size: 4.2
					},
					{
						name: 'slider_bg',
						size: 79,
						align: 'center'
					}
				]
			}
		},
		{
			name: 'rightgrid-land',
			type: 'PortrateGridController',
			size: 35,
			config: {
				gap: 1,
				size: 100,
				align: 'left',
				padding: {
					top: 0,
					bottom: 5,
					right: 10
				},
				main: [
					{
						name: 'empty',
						size: 7
					},
					{
						name: 'fg',
						size: 30,
						align: 'bottom_center',
						bounds: {
							width: 245,
							height: 110
						}
					},
					{ name: 'empty', size: 20 },
					{
						name: 'texts',
						size: 5,
						align: 'bottom_center',
						bounds: {
							width: 450,
							height: 1
						}
					},
					{ name: 'empty', size: 20 },
					{
						name: 'ui_splash_screen_btn',
						size: 17,
						align: 'bottom_center',
						bounds: {
							width: 245,
							height: 135
						}
					},
					{ name: 'empty', size: 12 },
					{
						name: 'ui_splash_screen_checkbox',
						size: 10,
						align: 'bottom_center',
						bounds: {
							width: 400,
							height: 70
						}
					}
				]
			}
		}
	]
};
